import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ member }) => {
  const [photoPreview, setPhotoPreview] = useState(null);

  const handlePhotoUpload = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader?.result);
      };
      reader?.readAsDataURL(file);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-6 flex-wrap">
        {/* Profile Photo */}
        <div className="relative">
          <div
            className="w-24 h-24 rounded-full flex items-center justify-center text-white font-bold text-2xl overflow-hidden"
            style={{ backgroundColor: member?.color }}
          >
            {photoPreview ? (
              <img src={photoPreview} alt={member?.name} className="w-full h-full object-cover" />
            ) : (
              member?.initials
            )}
          </div>
          <label
            htmlFor="photo-upload"
            className="absolute bottom-0 right-0 bg-primary text-primary-foreground p-2 rounded-full cursor-pointer hover:bg-primary/90 transition-colors shadow-warm-md"
          >
            <Icon name="camera" size={16} />
            <input
              id="photo-upload"
              type="file"
              accept="image/*"
              onChange={handlePhotoUpload}
              className="sr-only"
            />
          </label>
        </div>

        {/* Member Info */}
        <div className="flex-1">
          <h2 className="text-h2 font-heading text-foreground mb-1">{member?.name}</h2>
          <p className="text-muted-foreground mb-3">{member?.role} • Family Member</p>
          <div className="flex items-center gap-2">
            <div
              className="w-4 h-4 rounded-full"
              style={{ backgroundColor: member?.color }}
            />
            <span className="text-sm text-muted-foreground">Assigned Color: {member?.color}</span>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="flex gap-2">
          <Button variant="outline" size="sm" iconName="download">
            Export Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;